/**
 * Returns the file extension of a given path name.
 * Example: "file.txt" returns ".txt".
 * @param pathName
 */
export const getFileExtension = (pathName: string) => {
  const dotIndex = pathName.lastIndexOf('.');
  if (dotIndex === -1) {
    return '';
  }

  if (dotIndex === 0) {
    // If the dot is at the start of the path, it indicates a hidden file or directory.
    // In this case, we return an empty string as there is no valid extension.
    return '';
  }

  const baseExtension = pathName.slice(dotIndex).toLowerCase();

  // When checking for file extensions of a URL, we should ignore any query parameters.
  const questionMarkIndex = baseExtension.indexOf('?');
  if (questionMarkIndex !== -1) {
    return baseExtension.slice(0, questionMarkIndex);
  }

  // When checking for file extensions of a URL, we should ignore any hash fragments.
  const hashIndex = baseExtension.indexOf('#');
  if (hashIndex !== -1) {
    return baseExtension.slice(0, hashIndex);
  }

  return baseExtension;
};
